import { fetchQuery, graphql } from "relay-runtime"
import { chHasMedicationSuggestionForDiagnosisCodeQuery } from "@/modules/patients/detail/episode-of-care/services/__generated__/chHasMedicationSuggestionForDiagnosisCodeQuery.graphql"
import { RelayEnvironment } from "@/relay-environment"

const query = graphql`
  query chHasMedicationSuggestionForDiagnosisCodeQuery($diagnosisCode: String!) {
    ch_hasMedicationSuggestionForDiagnosisCode(diagnosisCode: $diagnosisCode)
  }
`

export const hasMedicationSuggestionForDiagnosisCode = (diagnosisCode: string) => {
  const data = fetchQuery<chHasMedicationSuggestionForDiagnosisCodeQuery>(RelayEnvironment, query, { diagnosisCode })
  return data.toPromise().then((res) => !!res?.ch_hasMedicationSuggestionForDiagnosisCode)
}
